import { createStore, guard } from 'effector';

import { not } from 'libs/bool';
import { RootDomain } from 'model/root.model';
import { isDesktop, isMobile } from 'libs/is-mobile';
import { ErrorDetails, IPInfoResult, MountType, VerifyParams } from 'model/domain';

export const changeOpenLinkParams = RootDomain.event<{ q?: string }>();
export const initialize = RootDomain.event();
export const unmountVerify = RootDomain.event();
export const configureVerify = RootDomain.event<VerifyParams>();
export const mountVerify = RootDomain.event<{ container: HTMLElement, sessionToken?: string, error?: ErrorDetails }>();
export const onMountVerify = RootDomain.event<{ container: HTMLElement, sessionToken?: string, error?: ErrorDetails }>();
export const fetchCountryFx = RootDomain.effect<void, IPInfoResult>();

export const countryCode$ = RootDomain.store<string>(null);
export const ipAddress$ = RootDomain.store<string>(null);
export const params$ = createStore<VerifyParams>(null);
export const mountType$ = createStore<MountType>(null);
export const isInquire$ = createStore(false);
export const sessionToken$ = RootDomain.store<string>(null);
export const openLinkParams$ = RootDomain.store<{ q?: string }>(null)
	.on(changeOpenLinkParams, (_, payload) => payload);

guard({
	source: mountVerify,
	filter: sessionToken$.map(token => token === null),
	target: onMountVerify,
});
guard({
	source: params$,
	filter: params => 'room' in params,
	target: changeOpenLinkParams.prepend((params: VerifyParams) => {
		return 'room' in params ? params.params : null;
	}),
});

params$
	.on(configureVerify, (_, params) => params);
mountType$
	.on(configureVerify, (_, params) => {
		let mountType;

		switch (true) {
			case isDesktop() && not('room' in params):
				mountType = MountType.fallback;
				break;
			case isMobile() && 'room' in params:
				mountType = MountType.crossDeviceVerification;
				break;
			case isMobile() && not('room' in params):
				mountType = MountType.verification;
				break;
			case isDesktop() && 'room' in params:
				mountType = MountType.invalid_device;
				break;
		}

		return mountType;
	});
isInquire$
	.on(configureVerify, (_, params) => 'options' in params && 'intent' in params.options);
sessionToken$
	.on(onMountVerify, (_, { sessionToken }) => sessionToken);
